export default "<div id=\"error-container\">\n  <mat-icon>error</mat-icon>\n  <span id=\"error-message\">{{ errorMessage }}</span>\n</div>\n"